import React from 'react'
import {Flex} from '/app/src/component'
import FeedbackRightPanel from '../RightPanel'

class CategoryRightPanel extends React.Component {
    render() {
        const {faqId} = this.props
        return (
            <Flex w='100%'>
                <FeedbackRightPanel faqId={faqId}/>
            </Flex>
        )
    }
}

export default CategoryRightPanel;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/Category/index.js